"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _debounce = _interopRequireDefault(require("@mui/utils/debounce"));
var _default = exports.default = _debounce.default;
